import type { TrackingError } from "./models";

/** A request the feed refused (its acknowledgement's `{ error }`), or one that
 *  timed out (`TRACKING_TIMEOUT`). */
export class TrackingRequestError extends Error implements TrackingError {
  readonly code: string;

  constructor(error: TrackingError) {
    super(error.message);
    this.name = "TrackingRequestError";
    this.code = error.code;
  }
}

export function isTrackingRequestError(error: unknown): error is TrackingRequestError {
  return error instanceof TrackingRequestError;
}
